import { graphql } from '@generated/gql';

export const SEARCH_SECURITIES = graphql(/** GraphQL */ `
  query securitySearchSelectSearchSecurities(
    $input: FetchFinancialProductsInput!
  ) {
    fetchFinancialProducts(input: $input) {
      totalCount
      financialProducts {
        id
        ticker
        isCash
        taxRank
        translatedName {
          ...ProductTranslatedString
        }
        primaryAssetClass {
          id
          name
          translatedName {
            ...ProductTranslatedString
          }
        }
        secondaryAssetClass {
          id
          name
          translatedName {
            ...ProductTranslatedString
          }
        }
        tertiaryAssetClass {
          id
          name
          translatedName {
            ...ProductTranslatedString
          }
        }
      }
    }
  }
`);
